var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-label',[_c('v-rect',{attrs:{"config":_vm.tagConfig}}),_c('v-text',{ref:"text",attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }